// Линкове към правните страници. Живеят на API домейна, за да са публични
// и без вход — App Store и Google Play го изискват, а и потребителят трябва
// да може да ги прочете ПРЕДИ да се съгласи.

import React from 'react';
import { Linking, Text, View } from 'react-native';
import { API_URL } from './api';
import { COLORS } from './ui';
import { t } from './i18n';

export const PRIVACY_URL = `${API_URL}/privacy`;
export const TERMS_URL = `${API_URL}/terms`;

function Link({ url, children }: { url: string; children: string }) {
  return (
    <Text
      onPress={() => Linking.openURL(url)}
      style={{ color: COLORS.primary, textDecorationLine: 'underline' }}
    >
      {children}
    </Text>
  );
}

export function LegalLinks({ prefix }: { prefix?: string }) {
  return (
    <View style={{ marginTop: 8 }}>
      <Text style={{ color: COLORS.muted, fontSize: 13, lineHeight: 19 }}>
        {prefix ? `${prefix} ` : ''}
        <Link url={TERMS_URL}>{t('Общи условия')}</Link>
        {' '}{t('и')}{' '}
        <Link url={PRIVACY_URL}>{t('Политика за поверителност')}</Link>.
      </Text>
    </View>
  );
}
